<template>
  <ErrorDialogV2
    :value="show"
    @input="$emit('update:show', $event)"
    title="Are you sure you want to delete the selected groups?"
    confirmButtonText="Delete"
    cancelButtonText="Don't delete"
    :showCancelButton="true"
    @confirm="$emit('delete')"
  />
</template>

<script>
import ErrorDialogV2 from "@/components/ErrorDialogV2.vue";

export default {
  name: "DeleteGroupsDialog",
  components: {
    ErrorDialogV2,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
